export default "__VITE_ASSET__BGc3uHsj__"